// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"d6535f3b","518":"33fb07f3","753":"103e4e7b","907":"e9283162","923":"6817e558","929":"cbe9a272"}[chunkId] + ".chunk.js";
};